import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';
import { setCustomerRefresh } from './customerSlice';


// Thunk to fetch top topcategories
export const addToCartThunk = createAsyncThunk(
    'cart/addToCartThunk',
    async (data, { rejectWithValue ,dispatch}) => {
        try {
            const response = await api.addToCart(data);
            toast.success("Products added to cart successfully");
            dispatch(setCustomerRefresh())
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "error of adding product into cart");
        }
    }
);


// Thunk to fetch top topcategories
export const sendenquirytooutofstockproductsthunk = createAsyncThunk(
    'sendenquirytooutofstockproductsthunk',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.sendenquirytooutofstockproducts(data);
            toast.success("Enquiry sent successfully");

            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "error of sending enquiry");
        }
    }
);



export const getAllCartProductThunk = createAsyncThunk(
    'cart/getAllCartProduct',
    async (id, { rejectWithValue,dispatch }) => {
        try {
            const response = await api.getCartDetails(id);
             dispatch(setCustomerRefresh())
            return response.data?.data;
        } catch (error) {
            console.log(error);  
        }
    }
);


export const upadteCart = createAsyncThunk(
    'cart/upadteCart',
    async (data, { rejectWithValue,dispatch }) => {
        try {
            const response = await api.updateCart(data);
            // dispatch(setCartRefresh())
            return response.status;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteProductfromcart = createAsyncThunk(
    'cart/deleteProductFromCart',
    async(id,{rejectWithValue,dispatch})=>{
        try{
              const response = await api.deleteCartProducts(id)
              dispatch(setCartRefresh())
              toast.success('Product deleted successfully')
        }catch(err){
            console.log(err);   
            toast.error('something went wrong')
        }
    }
)

// Slice for categories
const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        cartData: [],
        loading: false,
        error: null,
        page: 1,
        productDetails: {},
        refresh : false
    },
    reducers: {
        setCartData: (state, action) => {
          state.cartData = action.payload
        },
        setCartRefresh:(state,action)=>{
            state.refresh = !state.refresh
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addToCartThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(addToCartThunk.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addToCartThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //getCartdetails
            .addCase(getAllCartProductThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllCartProductThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.cartData = action.payload;
            })
            .addCase(getAllCartProductThunk.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const { setProductPage,setCartData,setCartRefresh } = cartSlice.actions
export default cartSlice.reducer;

